import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '../../../../../../../../_metronic/helpers'
import { getLast10PersonsByBedService } from '../../../../services/booking.service'
import moment from 'moment'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  campamentoId?: string
  camaId?: string
  onSelectGuest?: (guest: any) => void
}

const ModalLastGuests: FC<Props> = ({ show, setShow, campamentoId, camaId, onSelectGuest }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [guests, setGuests] = useState<any[]>([])
  console.log(guests)
  console.log(show)
  useEffect(() => {
    if (show) {
      getLastGuests()
    } else {
      setGuests([])
    }
  }, [show, campamentoId])

  const getLastGuests = async () => {
    try {
      setLoading(true)
      const filter = {
        CamaId: camaId || undefined,
      }
      const response = await getLast10PersonsByBedService(filter)
      console.log(response)
      if (response.data) {
        console.log(response.data)

        setGuests(response?.data as any[] || [])
      }
    } catch (error) {
      console.error('Error getting last guests:', error)
      setGuests([])
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    setShow(false)
  }

  const handleSelectGuest = (guest: any) => {
    if (onSelectGuest) {
      onSelectGuest(guest)
    }
    handleClose()
  }

  console.log(guests)

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Últimos 10 Huéspedes</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          {loading ? (
            <div className='text-center py-10'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Cargando...</span>
              </div>
            </div>
          ) : guests.length === 0 ? (
            <div className='text-center py-10'>
              <p className='text-muted'>No se encontraron huéspedes recientes</p>
            </div>
          ) : (
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='min-w-100px'>Nro. Documento</th>
                    <th className='min-w-100px'>Nombres</th>
                    <th className='min-w-100px'>Contratista</th>
                    <th className='min-w-100px'>Fecha(Mes/Año)</th>
                  </tr>
                </thead>
                <tbody>
                  {guests.map((guest, index) => (
                    <tr key={guest.HuespedId || guest.NroDoc || index}>
                      <td>
                        <span className='text-gray-600'>{guest.NroDocumento || '-'}</span>
                      </td>
                      <td>
                        <span className='text-gray-700 fw-bold'>
                          {guest.Nombres || ''}
                        </span>
                      </td>
                      <td>
                        <span className='text-gray-600'>{guest.EmpresaContratista || '-'}</span>
                      </td>
                      <td>
                        <span className='text-gray-600'>
                          <span className='text-gray-600'>{guest.Periodo || '-'}</span>

                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className='modal-footer'>
          <button type='button' className='btn btn-light' onClick={handleClose}>
            Cerrar
          </button>
        </div>
      </div>
    </Modal>
  )
}

export { ModalLastGuests }
